import { orderBy } from 'lodash'
import * as types from 'store/types'

const initialState = {
  drafts: {
    my_drafts: [],
    shared_drafts: []
  },
  pages: {
    favorites: [],
    uncategorized_private_contents: [],
    shared_categories: [],
    private_categories: []
  },
  responses: {
    favorites: [],
    uncategorized_private_contents: [],
    shared_categories: [],
    private_categories: []
  },
  loading_category_id: null,

  showDeleteContentConfirm: false,
  deletingContent: {},

  showDeleteCategoryConfirm: false,
  deletingCategory: {},

  showCategoryModal: false,
  editingCategory: {},

  showContentPermissionModal: false,
  editingContentPermission: {},

  showMoveToCategoryModal: false,
  movingContent: {},

  showGlobalSearchModal: false,

  redirectToHome: false,
  page_general_category: { shared_users: [], contents: [], subcategories: [] },
  response_general_category: { shared_users: [], contents: [], subcategories: [] },

  recentlyViewedContent: {
    pages: [],
    responses: []
  },
  examples: {
    draft: null,
    response: null
  },

  showGuestSharingModal: false,
  sharingPage: null,
  refresh_on_sharing: false,

  isEditingContent: false,
  isRequestCallComplete: false, // Basically using this ti monitor if network call is complete
  errorBag: {},
  isLoading: false,
  isFullScreen: false,
  selectedPageOrDraft: null
}

const contentReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.RESET_CONTENT: {
      return initialState
    }
    case types.SET_CATEGORIES: {
      const newState = JSON.parse(JSON.stringify(state))
      for (const type of ['page', 'response']) {
        newState[`${type}s`].shared_categories = action.data.shared_categories.filter((c) => c.type === type)
        newState[`${type}s`].private_categories = action.data.private_categories.filter((c) => c.type === type)
      }

      const _return = {
        ...state,
        pages: { ...newState[`pages`] },
        responses: { ...newState[`responses`] },
        page_general_category: { ...state.page_general_category, ...newState[`pages`].shared_categories.filter((cat) => cat.is_general)[0] },
        response_general_category: { ...state.response_general_category, ...newState[`responses`].shared_categories.filter((cat) => cat.is_general)[0] }
      }
      // Bring "General" category on the top.
      _return.pages.shared_categories = orderBy(_return.pages.shared_categories, (category) => category.is_general, 'desc')

      // ORDER: response private_categories
      for (const index in _return.responses.private_categories) {
        _return.responses.private_categories[index].subcategories = orderBy(_return.responses.private_categories[index].subcategories, (c) => c.order, 'asc')
        for (const sub_index in _return.responses.private_categories[index].subcategories) {
          _return.responses.private_categories[index].subcategories[sub_index].subcategories = orderBy(
            _return.responses.private_categories[index].subcategories[sub_index].subcategories,
            (c) => c.order,
            'asc'
          )
        }
        _return.responses.private_categories[index].subcategories = orderBy(_return.responses.private_categories[index].subcategories, (c) => c.order, 'asc')
      }
      _return.responses.private_categories = orderBy(_return.responses.private_categories, (category) => category.order, 'asc')

      // ORDER: response shared_categories
      for (const index in _return.responses.shared_categories) {
        _return.responses.shared_categories[index].subcategories = orderBy(_return.responses.shared_categories[index].subcategories, (c) => c.order, 'asc')
        for (const sub_index in _return.responses.shared_categories[index].subcategories) {
          _return.responses.shared_categories[index].subcategories[sub_index].subcategories = orderBy(
            _return.responses.shared_categories[index].subcategories[sub_index].subcategories,
            (c) => c.order,
            'asc'
          )
        }
        _return.responses.shared_categories[index].subcategories = orderBy(_return.responses.shared_categories[index].subcategories, (c) => c.order, 'asc')
      }
      _return.responses.shared_categories = orderBy(_return.responses.shared_categories, (category) => category.order, 'asc')

      // Keep Contents As it is
      for (const type of ['pages', 'responses']) {
        for (const sharing of ['private_categories', 'shared_categories']) {
          for (const i in _return[type][sharing]) {
            const state_cat_i = state[type][sharing].findIndex((cat) => cat.id === _return[type][sharing][i].id)
            if (state_cat_i !== -1) {
              _return[type][sharing][i]['contents'] = state[type][sharing][state_cat_i]['contents'] || []

              for (const ii in _return[type][sharing][i]['subcategories']) {
                const state_subcat_i = state[type][sharing][state_cat_i]['subcategories'].findIndex((cat) => cat.id === _return[type][sharing][i]['subcategories'][ii].id)
                if (state_subcat_i !== -1) {
                  _return[type][sharing][i]['subcategories'][ii]['contents'] = state[type][sharing][state_cat_i]['subcategories'][state_subcat_i]['contents'] || []

                  for (const iii in _return[type][sharing][i]['subcategories'][ii]['subcategories']) {
                    const state_subsubcat_i = state[type][sharing][state_cat_i]['subcategories'][state_subcat_i]['subcategories'].findIndex(
                      (cat) => cat.id === _return[type][sharing][i]['subcategories'][ii]['subcategories'][iii].id
                    )
                    if (state_subsubcat_i !== -1) {
                      _return[type][sharing][i]['subcategories'][ii]['subcategories'][iii]['contents'] =
                        state[type][sharing][state_cat_i]['subcategories'][state_subcat_i]['subcategories'][state_subsubcat_i]['contents'] || []
                    }
                  }
                }
              }
            }
          }
        }
      }

      return _return
    }
    case types.SET_SORTED_CATEGORIES: {
      return state
    }
    case types.SET_LOADING_CATEGORY_ID: {
      return {
        ...state,
        loading_category_id: action.uuid || null
      }
    }
    case types.SET_CONTENTS: {
      const _state = { ...state }
      const data = action.data
      const filters = action.filters
      const category_uuid = action.filters?.category_uuid
      if (category_uuid && filters?.type) {
        const type = `${filters?.type}s`
        for (const sharing_type of ['private_categories', 'shared_categories']) {
          for (const i in _state[type][sharing_type]) {
            const cat = _state[type][sharing_type][i]
            if (cat.uuid === category_uuid) {
              cat.contents = orderBy(data, (c) => c.pinned_to_category, 'desc')
              _state[type][sharing_type][i] = cat
              break
            } else {
              for (const ii in cat.subcategories) {
                const sub_cat = cat.subcategories[ii]
                if (sub_cat.uuid === category_uuid) {
                  sub_cat.contents = orderBy(data, (c) => c.pinned_to_category, 'desc')
                  cat.subcategories[ii] = sub_cat
                  _state[type][sharing_type][i] = cat
                  break
                } else {
                  for (const iii in sub_cat.subcategories) {
                    const sub_sub_cat = sub_cat.subcategories[iii]
                    if (sub_sub_cat.uuid === category_uuid) {
                      sub_sub_cat.contents = orderBy(data, (c) => c.pinned_to_category, 'desc')
                      sub_cat.subcategories[iii] = sub_sub_cat
                      cat.subcategories[ii] = sub_cat
                      _state[type][sharing_type][i] = cat
                      break
                    }
                  }
                }
              }
            }
          }
        }
      }
      return {
        ...state,
        pages: JSON.parse(JSON.stringify(_state['pages'])),
        responses: JSON.parse(JSON.stringify(_state['responses'])),
        loading_category_id: null
      }
    }
    case types.SET_PRIVATE_AND_FAVORITE_CONTENT: {
      const _state = { ...state }
      const data = action.data
      const type = action.content_type
      _state[`${type}s`]['uncategorized_private_contents'] = data.uncategorized_private_contents?.filter((item) => item.type === type)
      _state[`${type}s`]['favorites'] = data.favorites?.filter((item) => item.type === type)

      // Response orderby ORDER
      return {
        ..._state,
        [`${type}s`]: {
          ..._state[`${type}s`],
          uncategorized_private_contents: _state[`${type}s`].uncategorized_private_contents,
          favorites: _state[`${type}s`].favorites
        }
      }
    }
    case types.SET_DRAFTS: {
      const _return = {
        ...state,
        drafts: { ...action.data }
      }
      return _return
    }
    case types.SHOW_CATEGORY_MODAL: {
      return {
        ...state,
        showCategoryModal: action.status,
        editingCategory: action.category || {}
      }
    }
    case types.SHOW_CONTENT_PERMISSION_MODAL: {
      return {
        ...state,
        showContentPermissionModal: action.status,
        editingContentPermission: action.content || {}
      }
    }
    case types.SHOW_DELETE_CONTENT_CONFIRM: {
      console.log('e reach here');
      return {
        ...state,
        showDeleteContentConfirm: action.status,
        deletingContent: action.content || {},
        redirectToHome: action.redirectToHome || false
      }
    }

    case types.SET_IS_EDITING_CONTENT: {
      return {
        ...state,
        isEditingContent: action.isEditingStatus
      }
    }

    case types.SHOW_MOVE_TO_CATEGORY_MODAL: {
      return {
        ...state,
        showMoveToCategoryModal: action.showMoveToCategoryModal,
        movingContent: action.content || {}
      }
    }
    case types.SHOW_DELETE_CATEGORY_CONFIRM: {
      return {
        ...state,
        showDeleteCategoryConfirm: action.status,
        deletingCategory: action.category || {},
        redirectToHome: action.redirectToHome || false
      }
    }
    case types.SET_RECENT_VIEWED_CONTENT: {
      return {
        ...state,
        recentlyViewedContent: { ...action.data.recently_viewed },
        examples: {
          draft: action.data.examples.draft || null,
          response: action.data.examples.response || null
        }
      }
    }
    case types.SHOW_GLOBAL_SEARCH_MODAL: {
      return {
        ...state,
        showGlobalSearchModal: action.status
      }
    }
    case types.TOGGLE_GUEST_SHARING_MODAL: {
      return {
        ...state,
        showGuestSharingModal: action.status,
        sharingPage: action.sharingPage || null
      }
    }
    case types.REFRESH_ON_SHARING: {
      return {
        ...state,
        refresh_on_sharing: action.status || false
      }
    }
    case types.SET_IS_REQUEST_CALL_COMPLETE: {
      return {
        ...state,
        isRequestCallComplete: action.payload || false,
        isLoading: action?.payload ? false : true
      }
    }
    case types.SET_ERROR_BAG: {
      return {
        ...state,
        errorBag: action.payload
      }
    }
    case types.SET_FULLSCREEN_STATUS: {
      return {
        ...state,
        isFullScreen: action.payload
      }
    }

    case types.SET_SELECTED_PAGE_OR_DRAFT:
      {
        return {
          ...state,
          selectedPageOrDraft: action.payload
        }
      }
    default:
      return state
  }
}
export default contentReducer
